export default "__VITE_ASSET__CZwwDMmH__"